<template>
  <div
    class="s-list-item"
    :class="{'s-list-item__disabled': disabled, 's-list-item__active': active}"
    @click="disabled ? null : $emit('click')">
    <sTooltip
      v-if="mini"
      :border="false"
      :content="$t(item.name)"
      placement="right"
      type="dark">
      <sIcon
        class="mx-auto my-auto"
        line-height="34px"
        size="15"
        :type="item.icon || 'checkbox-empty'"/>
    </sTooltip>
    <div
      v-show="!mini"
      class="flex flex-between ma-0 pa-0 type-item width-100">
      <slot
        :item="item"
        name="item_text">
        <div class="type-name pr-1">
          {{ $t(item.name) }}
        </div>
        <div
          v-if="showCount"
          class="type-count">
          <slot name="count">
            <template v-if="item.count">
              {{ item.count }}
            </template>
            <template v-else-if="items && items.length">
              {{ item.filter ? items.filter(item.filter).length : items.length }}
            </template>
          </slot>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'navBarListItem',
  props: {
    mini: Boolean,
    disabled: Boolean,
    item: Object,
    items: Array,
    index: Number,
    active: Boolean,
    showCount: {
      type: Boolean,
      default: true,
    },
  }
}
</script>
<style scoped lang="scss">
.s-list-item {
  font-weight: 500;
  font-size: 15px;
  min-height: 40px;
  align-items: center;
  display: flex;
  flex: 1 1 100%;
  letter-spacing: normal;
  /*min-height: 48px;*/
  outline: none;
  padding: 0 16px;
  position: relative;
  text-decoration: none;
  cursor: pointer;
  text-align: left !important;
  &__active,
  &:focus,
  &:hover {
      background-color: var(--v-secondary__green_chosen-base);
  }
  &::after {
    content: "";
    min-height: inherit;
    font-size: 0;
  }
  &__disabled {
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
